import { render, staticRenderFns } from "./CommentsModal.vue?vue&type=template&id=59b7a999&scoped=true"
import script from "./CommentsModal.vue?vue&type=script&lang=js"
export * from "./CommentsModal.vue?vue&type=script&lang=js"
import style0 from "./CommentsModal.vue?vue&type=style&index=0&id=59b7a999&prod&lang=scss&scoped=true"
import style1 from "./CommentsModal.vue?vue&type=style&index=1&id=59b7a999&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b7a999",
  null
  
)

export default component.exports